/* =========================================================================
   lits-storyselling.js
   v3.6 — dynamic CTA-sub aligned to LITS 10% OFF / 15% OFF auto-discounts.
   v3.0: gallery thumb swap clears srcset/sizes so the main image updates.
   v3.1: footer 'Help' column heading renamed to 'Support'.
   v3.2: Find Your Flavour quiz — 'Pet' relabelled, share image card.
   v3.3: share-card avatar SVG gets an xmlns so the persona icon rasterizes.
   v3.4: gallery preloads full-size images on idle so switching is instant.
   v3.5: PDP tagline overrides for bodhi / casper / lime (interim, front-end).
   v3.6: Amma's Malaysian Sambal tagline override added.
   ========================================================================= */
(function () {
  'use strict';

  function bind(el) {
    if (!el || el.dataset.litsBound === '1') return false;
    el.dataset.litsBound = '1';
    return true;
  }

  function initQtySteppers(root) {
    root.querySelectorAll('[data-lits-qty]').forEach(function (stepper) {
      if (!bind(stepper)) return;
      var display = stepper.querySelector('span');
      var btns = stepper.querySelectorAll('button');
      if (!display || btns.length < 2) return;
      var hiddenInput = stepper.querySelector('input[type="hidden"]');
      var min = parseInt(stepper.getAttribute('data-min') || '1', 10);
      var max = parseInt(stepper.getAttribute('data-max') || '99', 10);
      function setVal(n) {
        n = Math.max(min, Math.min(max, n));
        display.textContent = n;
        if (hiddenInput) hiddenInput.value = n;
        stepper.dispatchEvent(new CustomEvent('lits:qty-change', { detail: { value: n }, bubbles: true }));
      }
      btns[0].addEventListener('click', function (e) { e.preventDefault(); setVal(parseInt(display.textContent, 10) - 1); });
      btns[1].addEventListener('click', function (e) { e.preventDefault(); setVal(parseInt(display.textContent, 10) + 1); });
    });
  }

  function initBundles(root) {
    root.querySelectorAll('[data-lits-bundles]').forEach(function (group) {
      if (!bind(group)) return;
      var opts = group.querySelectorAll('.bundle-opt');
      function fireBundleChange(opt) {
        group.dispatchEvent(new CustomEvent('lits:bundle-change', {
          detail: {
            variantId: opt.getAttribute('data-variant-id'),
            qty: parseInt(opt.getAttribute('data-qty') || '1', 10)
          },
          bubbles: true
        }));
      }
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
          fireBundleChange(opt);
        });
      });
      var selected = group.querySelector('.bundle-opt.selected');
      if (selected) {
        var qty = parseInt(selected.getAttribute('data-qty') || '1', 10);
        var container = group.closest('form') || group.closest('section') || document;
        var stepper = container.querySelector('[data-lits-qty]');
        if (stepper) {
          var display = stepper.querySelector('span');
          if (display) display.textContent = qty;
          var hidden = stepper.querySelector('input[name="quantity"]');
          if (hidden) hidden.value = qty;
        }
        updateCtaSub(qty);
      }
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-lits-gallery]').forEach(function (gallery) {
      if (!bind(gallery)) return;
      var mainImg = gallery.querySelector('.gallery-main img');
      var thumbs = gallery.querySelectorAll('.thumb');
      if (!mainImg || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullUrl = thumb.getAttribute('data-full');
          var thumbImg = thumb.querySelector('img');
          if (!fullUrl && thumbImg) fullUrl = thumbImg.getAttribute('src');
          if (!fullUrl) return;
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = fullUrl;
        });
      });
      var preloadFulls = function () {
        thumbs.forEach(function (t) { var u = t.getAttribute('data-full'); if (u) { var pi = new Image(); pi.decoding = 'async'; pi.src = u; } });
      };
      if ('requestIdleCallback' in window) { requestIdleCallback(preloadFulls, { timeout: 2500 }); }
      else { setTimeout(preloadFulls, 1200); }
    });
  }

  function initFooterLabels() {
    document.querySelectorAll('.footer-col h5').forEach(function (h) {
      if (h.textContent.trim() === 'Help') h.textContent = 'Support';
    });
  }

  /* Interim PDP tagline overrides (front-end). Bake into product templates once final. */
  function initPdpTaglines() {
    if (document.body.dataset.litsTagBound === '1') return;
    var p = location.pathname;
    var i = p.indexOf('/products/');
    if (i < 0) return;
    var handle = p.slice(i + 10).split('/')[0].split('?')[0];
    var tags = {
      'bodhi': "Wake up your tastebuds to a flavour they've never met.",
      'project-casper': "Peach, maple, garlic: wing night just found its forever sauce.",
      'lime-chili': "Bright, citrusy salsa verde with just a whisper of heat.",
      'ammas-malaysian-sambal': "Some flavours feed you. This one feels like being looked after."
    };
    var t = tags[handle];
    if (!t) return;
    document.body.dataset.litsTagBound = '1';
    var el = document.querySelector('.purchase .tagline') || document.querySelector('.tagline');
    if (el) el.textContent = t;
  }

  /* ---------- Find Your Flavour quiz enhancements ---------- */
  function roundRect(x, X, Y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    x.beginPath();
    x.moveTo(X + r, Y);
    x.arcTo(X + w, Y, X + w, Y + h, r);
    x.arcTo(X + w, Y + h, X, Y + h, r);
    x.arcTo(X, Y + h, X, Y, r);
    x.arcTo(X, Y, X + w, Y, r);
    x.closePath();
  }

  function downloadBlob(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = name || 'lits-flavour-match.png';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
  }

  function buildQuizCard(d, heatNum, cb) {
    var W = 1080, H = 1920;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var x = cv.getContext('2d');
    function wrap(text, cx, cy, maxW, lh, font, color) {
      x.font = font; x.fillStyle = color; x.textAlign = 'center';
      var words = (text || '').split(' '), line = '', yy = cy;
      for (var i = 0; i < words.length; i++) {
        var test = line ? line + ' ' + words[i] : words[i];
        if (x.measureText(test).width > maxW && line) { x.fillText(line, cx, yy); line = words[i]; yy += lh; }
        else line = test;
      }
      if (line) x.fillText(line, cx, yy);
      return yy;
    }
    x.fillStyle = '#0e0e0e'; x.fillRect(0, 0, W, H);
    x.fillStyle = '#F8C209'; x.fillRect(0, 0, W, 16); x.fillRect(0, H - 16, W, 16);
    x.textAlign = 'center';
    x.fillStyle = '#F8C209'; x.font = '800 30px Jost, Futura, Arial, sans-serif';
    x.fillText('F I N D   Y O U R   F L A V O U R', W / 2, 150);
    x.fillStyle = '#ffffff'; x.font = '800 42px Jost, Futura, Arial, sans-serif';
    x.fillText('LOST IN THE SAUCE', W / 2, 205);
    var avY = 280, avSize = 360;
    function drawRest() {
      x.textAlign = 'center';
      x.fillStyle = '#F8C209'; x.font = '800 28px Jost, Futura, Arial, sans-serif';
      x.fillText('YOUR FLAVOUR PERSONA', W / 2, avY + avSize + 66);
      wrap((d.name || '').toUpperCase(), W / 2, avY + avSize + 150, W - 160, 80, '900 70px Jost, Futura, Arial, sans-serif', '#ffffff');
      wrap(d.blurb, W / 2, avY + avSize + 250, W - 220, 44, '400 31px Georgia, serif', '#cfcabd');
      var sy = 1360;
      x.strokeStyle = 'rgba(255,255,255,0.18)'; x.lineWidth = 2;
      x.beginPath(); x.moveTo(140, sy - 56); x.lineTo(W - 140, sy - 56); x.stroke();
      x.fillStyle = '#F8C209'; x.font = '800 26px Jost, Futura, Arial, sans-serif';
      x.fillText('YOUR ESSENTIAL FLAVOUR', W / 2, sy);
      wrap(d.sauce, W / 2, sy + 60, W - 160, 56, '800 50px Jost, Futura, Arial, sans-serif', '#ffffff');
      var by = sy + 120, bw = 520, bx = (W - bw) / 2, bh = 22;
      x.fillStyle = '#2a2a2a'; roundRect(x, bx, by, bw, bh, 11); x.fill();
      var pct = Math.max(0, Math.min(1, heatNum / 10));
      var grad = x.createLinearGradient(bx, 0, bx + bw, 0);
      grad.addColorStop(0, '#F8C209'); grad.addColorStop(1, '#D6431F');
      x.fillStyle = grad; roundRect(x, bx, by, Math.max(bh, bw * pct), bh, 11); x.fill();
      x.fillStyle = '#ffffff'; x.font = '800 28px Jost, Futura, Arial, sans-serif'; x.textAlign = 'center';
      x.fillText('HEAT ' + (d.heat || ''), W / 2, by + 62);
      wrap('“' + d.fortune + '”', W / 2, by + 140, W - 240, 42, 'italic 30px Georgia, serif', '#F8C209');
      x.fillStyle = '#ffffff'; x.font = '700 30px Jost, Futura, Arial, sans-serif';
      x.fillText('Find your flavour at', W / 2, H - 152);
      x.fillStyle = '#F8C209'; x.font = '800 34px Jost, Futura, Arial, sans-serif';
      x.fillText('lostinthesauce.ca  ·  @litssauce', W / 2, H - 104);
      cb(cv);
    }
    if (d.avatarSVG) {
      var blob = new Blob([d.avatarSVG], { type: 'image/svg+xml;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () { x.drawImage(img, (W - avSize) / 2, avY, avSize, avSize); URL.revokeObjectURL(url); drawRest(); };
      img.onerror = function () { URL.revokeObjectURL(url); x.fillStyle = '#F8C209'; x.beginPath(); x.arc(W / 2, avY + avSize / 2, avSize / 2, 0, Math.PI * 2); x.fill(); drawRest(); };
      img.src = url;
    } else { drawRest(); }
  }

  function shareQuizCard(fyf, btn) {
    var get = function (s) { var el = fyf.querySelector(s); return el ? el.textContent.trim() : ''; };
    var d = { name: get('.fyf-r-name'), blurb: get('.fyf-r-blurb'), sauce: get('.fyf-r-sauce'), heat: get('.fyf-r-heat'), fortune: get('.fyf-r-fortune') };
    if (!d.name) return;
    var avEl = fyf.querySelector('.fyf-r-av svg');
    var svg = avEl ? avEl.outerHTML : '';
    if (svg && svg.indexOf('xmlns') === -1) svg = svg.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
    d.avatarSVG = svg.replace('width="100%"', 'width="360"').replace('height="100%"', 'height="360"');
    var heatNum = parseFloat(d.heat) || 6;
    var orig = btn.textContent; btn.textContent = 'Preparing…';
    buildQuizCard(d, heatNum, function (canvas) {
      btn.textContent = orig;
      canvas.toBlob(function (blob) {
        if (!blob) return;
        var file = new File([blob], 'lits-flavour-match.png', { type: 'image/png' });
        var msg = "I'm " + d.name + ' on the LITS flavour quiz. Find yours:';
        var data = { title: 'My LITS flavour match', text: msg, url: location.href };
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          data.files = [file];
          navigator.share(data).catch(function () {});
        } else if (navigator.share) {
          navigator.share(data).catch(function () { downloadBlob(blob); });
        } else {
          downloadBlob(blob);
        }
      }, 'image/png');
    });
  }

  function initFlavourQuiz() {
    var fyf = document.querySelector('[id^="fyf-"]');
    if (!fyf || fyf.dataset.litsQuizFix === '1') return;
    fyf.dataset.litsQuizFix = '1';
    var facts = fyf.querySelector('.fyf-r-facts');
    function fixPet() {
      fyf.querySelectorAll('.fyf-r-facts .fyf-fl').forEach(function (l) {
        if (l.textContent.trim() === 'Pet') l.textContent = 'Most likely pet';
      });
    }
    if (facts) { new MutationObserver(fixPet).observe(facts, { childList: true }); fixPet(); }
    var share = fyf.querySelector('.fyf-share');
    if (share) {
      var fresh = share.cloneNode(true);
      share.parentNode.replaceChild(fresh, share);
      fresh.addEventListener('click', function (e) { e.preventDefault(); shareQuizCard(fyf, fresh); });
    }
  }

  function initStickyShadow() {
    var bars = document.querySelectorAll('.promo, .nav, [data-lits-sticky]');
    if (!bars.length || document.body.dataset.litsStickyBound === '1') return;
    document.body.dataset.litsStickyBound = '1';
    function onScroll() {
      var scrolled = window.scrollY > 4;
      bars.forEach(function (b) { b.classList.toggle('scrolled', scrolled); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-lits-reveal]:not(.is-visible)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeatScales(root) {
    root.querySelectorAll('.heat-scale[data-heat]').forEach(function (scale) {
      if (!bind(scale)) return;
      var heat = parseFloat(scale.getAttribute('data-heat'));
      if (isNaN(heat)) return;
      var pct = Math.max(0, Math.min(100, (heat / 10) * 100));
      var marker = scale.querySelector('.heat-marker');
      if (marker) marker.style.left = pct + '%';
    });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('.lits-mobile-toggle');
    var menu = document.getElementById('lits-mobile-menu');
    var backdrop = document.querySelector('[data-lits-mobile-backdrop]');
    if (!toggle || !menu || !backdrop) return;
    if (!bind(toggle)) return;
    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.toggle('open', open);
      backdrop.classList.toggle('open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('lits-menu-open', open);
    }
    toggle.addEventListener('click', function () { setOpen(!menu.classList.contains('open')); });
    backdrop.addEventListener('click', function () { setOpen(false); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) setOpen(false);
    });
  }

  function pageHasMultiQtyBundles() {
    var bundles = document.querySelectorAll('[data-lits-bundles] .bundle-opt');
    var hasMulti = false;
    bundles.forEach(function (b) {
      if (parseInt(b.getAttribute('data-qty') || '1', 10) > 1) hasMulti = true;
    });
    return hasMulti;
  }

  function updateCtaSub(qty) {
    if (!pageHasMultiQtyBundles()) return;
    var ctaSubs = document.querySelectorAll('.add-cart-sub');
    if (!ctaSubs.length) return;
    qty = parseInt(qty, 10) || 0;
    var html;
    if (qty < 3) {
      var needed = 3 - qty;
      var word = needed === 1 ? 'bottle' : 'bottles';
      html = '🌶️ Add <strong>' + needed + '</strong> more ' + word + ' to unlock <strong>10% off</strong>';
    } else if (qty < 6) {
      var moreNeeded = 6 - qty;
      var wordB = moreNeeded === 1 ? 'bottle' : 'bottles';
      html = '🎉 <strong>10% off</strong> unlocked → add <strong>' + moreNeeded + '</strong> more ' + wordB + ' to save <strong>15%</strong>';
    } else {
      html = '🎁 <strong>15% off</strong> unlocked + free shipping on <strong>$50+</strong>';
    }
    for (var i = 0; i < ctaSubs.length; i++) { ctaSubs[i].innerHTML = html; }
  }

  function initCtaSub() {
    if (document.body.dataset.litsCtaBound === '1') return;
    document.body.dataset.litsCtaBound = '1';
    var ctaSub = document.querySelector('.add-cart-sub');
    if (!ctaSub) return;
    if (!pageHasMultiQtyBundles()) return;
    var stepper = document.querySelector('[data-lits-qty]');
    if (stepper) {
      var display = stepper.querySelector('span');
      if (display) updateCtaSub(parseInt(display.textContent, 10) || 1);
    }
    document.addEventListener('lits:qty-change', function (e) {
      if (e.detail) updateCtaSub(e.detail.value);
    });
    document.addEventListener('lits:bundle-change', function (e) {
      if (e.detail && e.detail.qty) updateCtaSub(e.detail.qty);
    });
  }

  function initAll(root) {
    root = root || document;
    initQtySteppers(root);
    initBundles(root);
    initGallery(root);
    initHeatScales(root);
  }
  function bootstrap() {
    initPdpTaglines();
    initAll();
    initStickyShadow();
    initReveal();
    initMobileMenu();
    initFooterLabels();
    initFlavourQuiz();
    initCtaSub();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initMobileMenu();
    initFlavourQuiz();
    initPdpTaglines();
  });
  window.LITS = window.LITS || {};
  window.LITS.init = initAll;
  window.LITS.initMobileMenu = initMobileMenu;
  window.LITS.updateCtaSub = updateCtaSub;
})();